import React, { PureComponent } from 'react';
import classnames from 'classnames';

import './ChartWrapper.styl';

class ChartWrapper extends PureComponent {
  render() {
    const { width, height, className } = this.props;
    const wrapperClasses = classnames('chart', className);
    return (
      <svg
        className={wrapperClasses}
        width={width}
        height={height}
        viewBox={`0,0,${width},${height}`}
        ref={ref => { this.svg = ref; }}
      >
        {this.props.children}
      </svg>
    );
  }
}

export default ChartWrapper;
